// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type { TagProps } from '@iheartjane/reefer';
import { JaneGoldIcon, Tag } from '@iheartjane/reefer';

import { truncateLabel } from '@jane/shared-ecomm/util';

import { useKioskSpacing } from '../../../hooks';
import { useComplianceLanguage } from '../../../providers';
import { capitalize } from '../../../util';

const StyledTag = styled(Tag)({
  maxWidth: '100%',
  overflow: 'hidden',
  p: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
});

const PaddedTag = styled(StyledTag)({
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 2,
  paddingBottom: 2,
});

interface DealTagProps extends Partial<TagProps> {
  isGold?: boolean;
  maxLabelLength?: number;
  tagLabel: string | null;
}

export const DealTag = ({
  isGold,
  maxLabelLength = 12,
  tagLabel,
  ...props
}: DealTagProps) => {
  const { isIpad } = useKioskSpacing();
  const { getWord } = useComplianceLanguage();
  const TagComponent = isIpad ? StyledTag : PaddedTag;
  return (
    <TagComponent
      background={isGold ? 'gold' : 'sunset'}
      color={isGold ? 'grays-black' : 'grays-white'}
      label={truncateLabel(
        tagLabel ? tagLabel : capitalize(getWord('deals_badge') ?? 'Deal'),
        maxLabelLength
      )}
      icon={
        isGold ? (
          <div>
            <JaneGoldIcon size="sm" />
          </div>
        ) : undefined
      }
      size="sm"
      {...props}
    />
  );
};
